import React from "react";
import { Modal, Row, Col, Form, Container, InputGroup } from "react-bootstrap";

import PageLoadingIndicator from "presentation/components/page-loading-indicator";
import PageAlert from "presentation/components/page-alert";

import CancelButton from "presentation/components/buttons/cancel";
import AddButton from "presentation/components/buttons/add";

import { handleChange, getInputValue } from "presentation/utils/functions/generic";

import EvaluationFormula from "presentation/pages/evaluation-schemes/elements/evaluation-formula/evaluation-formula";

import jointDisciplinesService from "presentation/services/joint-disciplines";
import evaluationResultLabelsService from "presentation/services/evaluation-result-labels";
import { TERM_INFO_ITEM_TYPE_DISCIPLINE } from "presentation/model/constants";


class ManageJointDisciplinesModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            form: {
                formula: []
            },
            evaluationResultLabels: []
        };
    }

    async componentDidMount() {
        let { jointDiscipline = {} } = this.props;

        await evaluationResultLabelsService.findAll().then((result) => {

            //TODO: tratar lista de disciplines para virar o campo form.disciplineId

            this.setState({ evaluationResultLabels: result, form: jointDiscipline }, () => this.loadTerms());
        });


    }


    loadTerms = (selectedDisciplines = []) => {
        let { disciplines } = this.props;

        let validDisciplines = [];

        if (selectedDisciplines) {
            validDisciplines = disciplines.filter(x => selectedDisciplines.includes(x.discipline.id.toString()));
        }

        let terms = validDisciplines.map((p, pi) => {
            return { id: p.id, displayName: p.discipline.name, machineName: `discipline:${p.id}`, isUnique: true, termInfoItemType: TERM_INFO_ITEM_TYPE_DISCIPLINE };
        });

        this.setState({ terms: terms, loading: false });
    }


    handleDisciplinesChange = (e, component) => {
        const { loadTerms } = this;
        handleChange(e, component);

        let selectedDisciplines = getInputValue(e);

        loadTerms(selectedDisciplines);
    }

    updateExpression = (entityKey, elements) => {
        const { form } = this.state;
        this.setState({ form: { ...form, formula: elements } });
    }

    onSubmit = async () => {
        let { courseId, academicPeriodId, loadData, onClose } = this.props;
        this.setState({ loading: true, actionLoading: true, error: '' });

        const {
            name,
            disciplineId
        } = this.state.form;

        if (!name || !disciplineId) {
            this.setState({ loading: false, error: true, message: "Por favor, preencha as informações básicas como disciplinas e ou nome dessa disciplina composta..." });
        } else {
            let postData = this.state.form;
            postData.courseId = courseId;
            postData.academicPeriodId = academicPeriodId;
            try {
                const response = await jointDisciplinesService.saveAssociated(postData);
                if (response.error == true) {
                    this.setState({
                        loading: false,
                        actionLoading: false,
                        error: true,
                        message: response.message
                    });
                } else {

                    this.setState({
                        loading: false,
                        error: '',
                    }, () => {
                        onClose();
                        loadData(courseId);
                    });

                }
            } catch (err) {
                this.setState({
                    loading: false,
                    actionLoading: false,
                    error: true,
                    message: err.message
                });
            }
        }
    };


    render() {
        let { show, onClose, disciplines, courseId, mode = "add" } = this.props;
        let { loading, form, terms, evaluationResultLabels, error, message } = this.state;

        const { onSubmit, updateExpression, handleDisciplinesChange } = this;

        let component = this;
        let entityKey = courseId;

        let existingElements = form.formula || [];
        let disciplinesList = disciplines.map((e, i) => { return e.discipline; });
        return (
            <Modal size="fullscreen" backdrop="static" show={show || false} onHide={onClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{mode == "add" ? "Adicionar" : "Editar"} disciplina composta</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loading === true && <PageLoadingIndicator loadingText={"Carregando informações..."} />}
                    {loading === false && error === true && <PageAlert className="m-b-20" message={"Erro"} description={message} type="danger" />}
                    {loading === false && disciplines.length > 0 && (
                        <Container>
                            <Row>
                                <Col lg={6}>
                                    <div className="form mt-2">
                                        <Form.Label htmlFor="name">Nome</Form.Label>
                                        <Form.Control
                                            type="text"
                                            id="name"
                                            name="name"
                                            defaultValue={form.name}
                                            onChange={(e) => handleChange(e, component)}
                                            aria-describedby="nameHelpBlock"
                                        />
                                        <Form.Text id="nameHelpBlock" muted>
                                            Informe o nome da disciplina composta
                                        </Form.Text>
                                    </div>
                                </Col>
                                <Col lg={6}>
                                    <div className="form mt-2">
                                        <Form.Label htmlFor="shortName">Nome de exibição</Form.Label>
                                        <Form.Control
                                            type="text"
                                            id="shortName"
                                            name="shortName"
                                            defaultValue={form.shortName}
                                            onChange={(e) => handleChange(e, component)}
                                            aria-describedby="shortNameHelpBlock"
                                        />
                                        <Form.Text id="shortNameHelpBlock" muted>
                                            Informe o nome de exibição da disciplina composta
                                        </Form.Text>
                                    </div>
                                </Col>
                                <Col lg={12}>
                                    <Form.Label htmlFor="disciplineId">Disciplinas</Form.Label>
                                    <Form.Select
                                        aria-label="Disciplinas"
                                        value={form.disciplineId}
                                        id={`disciplineId`}
                                        name={`disciplineId`}
                                        data-field-name="disciplineId"
                                        onChange={(e) => handleDisciplinesChange(e, component)}
                                        multiple={true}
                                    >
                                        {disciplinesList.map((e, i) => { return <option key={e.id} value={e.id}>{e.name}</option> })}
                                    </Form.Select>
                                </Col>
                                <Col>
                                    <div className="form mt-2">
                                        <Form.Label htmlFor="allowIndividualFailure">Opções de avaliação</Form.Label>
                                        <Form.Check
                                            type="checkbox"
                                            id="allowIndividualFailure"
                                            name="allowIndividualFailure"
                                            label={"Mesmo agrupadas as disciplinas são avaliadas individualmente"}
                                            checked={form.allowIndividualFailure}
                                            onChange={(e) => handleChange(e, component)}
                                        />
                                    </div>
                                </Col>
                                <Col>
                                    <div className="form mt-2">
                                        <Form.Label htmlFor="discipline">Rótulo de resultado</Form.Label>
                                        <Form.Select
                                            aria-label="Rótulo de resultado"
                                            defaultValue={form.evaluationResultLabelId}
                                            id="evaluationResultLabelId"
                                            name="evaluationResultLabelId"
                                            onChange={(e) => handleChange(e, component)}
                                            aria-describedby="evaluationResultLabelIdHelpBlock"
                                        >
                                            <option value="-1">Sem rótulo</option>
                                            {evaluationResultLabels.map((e, i) => { return <option key={e.id} value={e.id}>{e.name}</option> })}
                                        </Form.Select>
                                        <Form.Text id="evaluationResultLabelIdHelpBlock" muted>
                                            Defina a qual rótulo de resultado dessa disciplina
                                        </Form.Text>
                                    </div>
                                </Col>
                            </Row>
                            {!form.allowIndividualFailure &&
                                <div className="mt-2">
                                    <strong>Fórmula:</strong>
                                    <EvaluationFormula component={component} entityKey={entityKey} sortableKey={`ev-status-situation-${entityKey}`} updateExpression={updateExpression} terms={terms} existingElements={existingElements} />
                                </div>
                            }
                        </Container>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <CancelButton
                        containerProps={{
                            disabled: loading,
                            onClick: onClose
                        }}
                    />
                    <AddButton
                        title={"Salvar"}
                        containerProps={{
                            onClick: () => onSubmit(),
                            variant: 'success',
                            disabled: loading
                        }}
                    />
                </Modal.Footer>
            </Modal >
        );
    };
}

export default ManageJointDisciplinesModal;